import React, { useState, useEffect, useRef } from 'react';
import { useField } from '@rocketseat/unform';
import { MdPhoto } from 'react-icons/md';
import PropTypes from 'prop-types';

import { InputFileContent } from './styles';

export default function ImageInput({ name, getImage, image }) {
  const { registerField } = useField(name);

  const [imagePreview, setImagePreview] = useState('');

  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      registerField({
        name,
        ref: ref.current,
        path: 'dataset.file',
      });
    }
  }, [image, name, ref, registerField]);

  function handleChange(e) {
    const filePreview = e.target.files[0];
    if (filePreview) {
      getImage(filePreview);
      setImagePreview(URL.createObjectURL(filePreview));
    } else {
      setImagePreview('');
    }
  }

  return (
    <InputFileContent>
      <label>
        {!imagePreview && !image ? (
          <>
            <MdPhoto size={40} color="#ddd" />
            Adicionar foto
          </>
        ) : (
          <img src={imagePreview || image} alt="Avatar" />
        )}
        <input
          type="file"
          id={name}
          accept="image/*"
          data-file={!!imagePreview}
          onChange={handleChange}
          ref={ref}
        />
      </label>
    </InputFileContent>
  );
}

ImageInput.propTypes = {
  getImage: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
};

ImageInput.defaultProps = {
  image: '',
};
